// extracted by mini-css-extract-plugin
export default {"card":"Card_card__FYQMH","cardTitle":"Card_cardTitle__jYzQJ","cardDesc":"Card_cardDesc__GvBnB","price":"Card_price__GiT7U"};